/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询项目限时抢购活动信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.FlashSaleDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/flashes/${productId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
